
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './config/msalConfig';
import { store, } from './app/store';
// import MainApp from './MainApp'; // <-- Import the new component
import MsalInitializer from './MsalInitializer'; 
import { Toaster } from './components/Shared/Toaster';

// Remove the MSAL event callback and handleRedirectPromise from here
// as they are now in MainApp.tsx

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
if (msalInstance) {
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <MsalProvider instance={msalInstance}>
            <BrowserRouter>
              <Toaster />
              <MsalInitializer />
            </BrowserRouter>
          </MsalProvider>
        </Provider>
      </React.StrictMode>
    );
} else {
    // Render a loading or error state if MSAL is not initialized
    root.render(<div>Error: MSAL not initialized.</div>);
}